import React from "react";

const UserCurrentNewsItems = ({ post }) => {
  return (
    <div
      style={{
        background: "rgba(255, 255, 255, 0.05)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        borderRadius: "8px",
        padding: "15px",
        color: "white",
        transition: "background 0.2s ease",
      }}
      onMouseOver={(e) =>
        (e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)")
      }
      onMouseOut={(e) =>
        (e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)")
      }
    >
      {/* Header: Avatar, Author, Timestamp & Category Badge */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "15px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {/* Avatar Placeholder */}
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "#7b00ff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              fontSize: "1.1rem",
            }}
          >
            {post.author.charAt(0)}
          </div>

          <div>
            <div style={{ fontWeight: "bold", fontSize: "1rem" }}>
              {post.author}
            </div>
            <div
              style={{ fontSize: "0.75rem", color: "#aaa", marginTop: "2px" }}
            >
              {post.timestamp}
            </div>
          </div>
        </div>

        {/* Category Badge */}
        <div
          style={{
            background: "rgba(123, 0, 255, 0.2)",
            color: "#cc88ff",
            padding: "4px 10px",
            borderRadius: "12px",
            fontSize: "0.75rem",
            border: "1px solid #7b00ff",
          }}
        >
          {post.category}
        </div>
      </div>

      {/* Post Text Content */}
      <div
        style={{
          fontSize: "0.95rem",
          lineHeight: "1.5",
          marginBottom: "15px",
          color: "#eee",
        }}
      >
        {post.content}
      </div>

      {/* Action Buttons (Like, Comment, Share) */}
      <div
        style={{
          display: "flex",
          gap: "20px",
          borderTop: "1px solid rgba(255, 255, 255, 0.1)",
          paddingTop: "12px",
        }}
      >
        <button
          style={{
            background: "transparent",
            border: "none",
            color: "#aaa",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <span>❤️</span> {post.likes}
        </button>
        <button
          style={{
            background: "transparent",
            border: "none",
            color: "#aaa",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <span>💬</span> {post.comments}
        </button>
        <button
          style={{
            background: "transparent",
            border: "none",
            color: "#aaa",
            cursor: "pointer",
            marginLeft: "auto",
          }}
        >
          🔗 Share
        </button>
      </div>
    </div>
  );
};

export default UserCurrentNewsItems;
